import * as React from 'react';
import { AvenyContextConsumer } from '../../Features/AvenyContext';

interface IProps {
  children: React.ReactNode;
}

const HideInSingleRoutineMode: React.FC<
  React.PropsWithChildren<IProps>
> = props => (
  <AvenyContextConsumer>
    {avenyContext =>
      avenyContext.singleRoutineMode.enabled ? null : props.children
    }
  </AvenyContextConsumer>
);

export default HideInSingleRoutineMode;
